module.exports = __webpack_public_path__ + "img/fruit-gooseberries-350x184.cb283fcf.jpg";